module.exports = __webpack_public_path__ + "static/img/fuc-bgs.2359b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/fuc-bgs.png
// module id = v4YT
// module chunks = 0